module.exports = __webpack_public_path__ + "static/media/storyimg2.7b156aaa.png";